import { Webhook } from '@nemuru-eng/js-api-client';

import { WebhookMap } from '@/components/modules/Webhooks/maps/webhook.map';
import { AddOrEditWebhookFormType } from '@/components/modules/Webhooks/schemas/AddOrEditWebhookForm.schema';
import { AuthorizationType } from '@/components/modules/Webhooks/schemas/AuthorizationType';

interface AddOrEditWebhooksFormValuesProps {
  webhook: Webhook | undefined;
  autocomplete?: boolean;
}

export const addOrEditWebhooksFormValues = ({
  webhook,
  autocomplete = false,
}: AddOrEditWebhooksFormValuesProps): AddOrEditWebhookFormType => {
  if (webhook) {
    return WebhookMap.toForm(webhook);
  }

  if (autocomplete) {
    return defaultValues;
  }

  return {
    target: '',
    // @ts-expect-error: we set an empty value (instead of enum) to show placeholder and avoid "undefined" fields error
    authorizationType: '',
    additionalPayload: '',
    authorizationHeader: '',
    authorization: {
      url: '',
      clientId: '',
      clientSecret: '',
      username: '',
      password: '',
    },
  };
};

const defaultValues = {
  target: 'http://www.your-domain.com/notifications',
  authorizationType: AuthorizationType.NO_AUTH as const,
  additionalPayload: '',
};
